import { useEffect } from 'react';
import { compose } from 'ramda';
import queryString from 'query-string';
import Cookies from 'js-cookie';

import StoreProvider from 'components/StoreProvider/StoreProvider';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import AUTH from 'consts/auth';

const { connect, actions, selectors } = StoreProvider;

const Logout = ({ isSignedIn, signOut, history: { location } }: any) => {
  const isProduction = process.env.NODE_ENV === 'production';
  const { redirect_url } = queryString.parse(location.search);
  Cookies.remove(AUTH.TOKEN, {
    path: '/',
    domain: isProduction ? '.deeptrue.com' : 'localhost',
  });
  signOut();

  useEffect(() => {
    if (!isSignedIn && redirect_url && !Array.isArray(redirect_url)) {
      window.location.replace(redirect_url);
    }
    // eslint-disable-next-line
  }, [isSignedIn]);

  return null;
};

export default compose(
  connect(
    (state) => ({
      isSignedIn: selectors.authSelectors.isSignedIn(state),
    }),
    {
      signOut: actions.authActions.signOut,
    }
  ),
  withMetaDescription({ title: 'Deeptrue logout' })
)(Logout);
